import React from 'react';
import { Layers3, PackageCheck, Wheat } from '@/components/icons';
import { cn } from '@/lib/utils';

const TYPES = {
  raw: { label: 'Materia prima', icon: Wheat, cls: 'bg-slate-50 text-slate-700 border-slate-200', iconCls: 'text-slate-600' },
  raw_material: { label: 'Materia prima', icon: Wheat, cls: 'bg-slate-50 text-slate-700 border-slate-200', iconCls: 'text-slate-600' },
  semifinished: { label: 'Semilavorato', icon: Layers3, cls: 'bg-blue-50 text-blue-700 border-blue-200', iconCls: 'text-blue-600' },
  final_product: { label: 'Prodotto finito', icon: PackageCheck, cls: 'bg-slate-50 text-slate-700 border-slate-200', iconCls: 'text-slate-700' }
};

export default function ProductTypeBadge({ type, compact = false, iconOnly = false, className }) {
  const cfg = TYPES[type] || TYPES.raw;
  const Icon = cfg.icon;
  if (iconOnly) return <span className={cn('inline-flex items-center justify-center', cfg.iconCls, className)} role="img" aria-label={cfg.label} title={cfg.label}><Icon className="h-4 w-4" aria-hidden="true" /></span>;
  return <span className={cn('inline-flex items-center gap-1.5 rounded-md border font-medium', compact ? 'px-2 py-1 text-[11px]' : 'px-2.5 py-1.5 text-xs', cfg.cls, className)}><Icon className="h-3.5 w-3.5" aria-hidden="true" />{cfg.label}</span>;
}
